<template>
    <ion-page>
        <ion-header>
            <ion-toolbar>
                <ion-buttons slot="end">
                    <ion-button @click="close()">
                        <ion-icon slot="icon-only" :icon="closeOutline"></ion-icon>
                    </ion-button>
                </ion-buttons>
                <ion-title>{{ shipment.reference }}</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content :fullscreen="true">
            <ion-list>
                <ion-item>
                    <ion-label><strong>Line {{ line.id }}</strong></ion-label>
                    <ion-button @click="markDone(line)">{{ line.packed_at?'':'Mark'}} Line Packed</ion-button>
                </ion-item>
                <ion-item>
                    <ion-label class="ion-text-wrap">
                        <h2>SKU: {{ line.sku.sku }} x {{ line.qty_checked }}</h2>
                        <p>{{ line.item.item_number }}</p>
                        <ion-text color="danger" v-if="line.packing_instructions"><p>{{ line.packing_instructions }}</p></ion-text>
                    </ion-label>
                </ion-item>
                <ion-item>
                    <ion-button size="medium" style="width:100%"
                                fill="outline"
                                color="dark"
                                class="ion-margin-top ion-margin-bottom"
                                @click="$refs.product.open()">Product Card
                    </ion-button>
                </ion-item>
            </ion-list>
            <product-card-modal ref="product" :item="line.item" :sku="line.sku" />
        </ion-content>
    </ion-page>
</template>

<script>
import {modalController} from '@ionic/vue';
import {
    IonContent, IonPage, IonLabel, IonItem, IonHeader,
    IonToolbar, IonTitle, IonList, IonButtons, IonButton, IonText, IonIcon
} from '@ionic/vue';

import EventBus from "@/EventBus";
import {closeOutline, checkmarkCircle} from 'ionicons/icons';
import ProductCardModal from "@/components/Modals/ProductCardModal";

/**
 * This is used when we're packing list items, as opposed to a regular
 * boxed up shipment.
 */
export default {
    props: ['shipment', 'line'],
    inject: ['$http', '$toast', '$validationAlert', '$scanner'],
    name: 'PackListItemModal',
    components: {
        ProductCardModal,
        IonContent, IonPage, IonLabel, IonItem, IonHeader, IonText,
        IonToolbar, IonTitle, IonList, IonButtons,
        IonButton, IonIcon
    },
    computed: {
        likelySubstitute() {
            return (this.line.sku?.item?.id !== this.line?.item?.id);
        },
        substituteInformation() {
            return `Looks like original '${this.line.sku.item.item_number}' has been substituted for '${this.line.item.item_number}'`;
        }
    },
    methods: {
        close() {
            modalController.dismiss();
        },
        /**
         * @param line
         */
        markDone(line) {
            EventBus().emitter.emit('loading', true);
            // send through a payload which contains: picked (count),
            // reason (object with id as a key), comment (string)
            this.$http.put(`/api/packs/shipments/${this.shipment.id}/lines/${line.id}`, {
                packed: true
            }).then( () => {
                line.packed_at = new Date();
                this.$toast.success('Box marked as done');
                EventBus().emitter.emit('loading', false);
                modalController.dismiss(true);
            }).catch(error => {
                EventBus().emitter.emit('loading', false);
                this.$validationAlert(error);
            });
        }
    },
    setup() {
        return {
            checkmarkCircle,
            closeOutline
        };
    }
}
</script>
